<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/publications/csr/csr_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'csr.Corporate Social Responsibility' | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/published-report">{{ 'report.Annual Report' | translate }}</a>
                    </li>      
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-financial">{{ 'report.Key Financial Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-operational">{{ 'report.Key Operational Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item active">
                        <a class="nav-link" href="/publication/csr">{{ 'report.CSR' | translate }}</a>
                    </li>             
                </ul>
            </div>
        </nav>
        <div class="csr">
            <div
                *ngFor="let post of socialActivityPosts; let i = index"
                [ngClass]="{
                    'social-activity': i === 0,
                    'financial': i !== 0 && i % 2 === 0,
                    'community': i % 2 === 1
                }">
                <h1 *ngIf="i === 0"><span style="color: #005EB8;">{{ 'csr.Social' | translate }}</span><span style="color: #FFB81C;"> {{ 'csr.Activities' | translate }}</span></h1>
                <div class="row" *ngIf="i === 0">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="post-image">
                            <a href="all-posts/detail/{{ post.id }}"><img [src]="baseApiUrl + '/' + post.banner_image_url" alt=""></a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'en'">{{ post.title }}</h2></a>
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'kh'">{{ post.title_kh }}</h2></a>
                        <p *ngIf="currentLang == 'en'" [innerHTML]="(post.desc | truncate:400) | safeText"></p>
                        <p *ngIf="currentLang == 'kh'" [innerHTML]="(post.desc_kh | truncate:400) | safeText"></p>
                        <a href="all-posts/detail/{{ post.id }}" class="read-more-btn">Read More →</a>
                    </div>
                </div>

                <div class="row" *ngIf="i % 2 === 1">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'en'">{{ post.title }}</h2></a>
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'kh'">{{ post.title_kh }}</h2></a>
                        <p *ngIf="currentLang == 'en'" [innerHTML]="(post.desc | truncate:400) | safeText"></p>
                        <p *ngIf="currentLang == 'kh'" [innerHTML]="(post.desc_kh | truncate:400) | safeText"></p>
                        <a href="all-posts/detail/{{ post.id }}" class="read-more-btn">Read More →</a>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="post-image">
                            <img [src]="baseApiUrl + '/' + post.image" alt="">
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="i !== 0 && i % 2 === 0">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="post-image">
                            <a href="all-posts/detail/{{ post.id }}"><img [src]="baseApiUrl + '/' + post.banner_image_url" alt=""></a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'en'">{{ post.title }}</h2></a>
                        <a href="all-posts/detail/{{ post.id }}"><h2 *ngIf="currentLang == 'kh'">{{ post.title_kh }}</h2></a>
                        <p *ngIf="currentLang == 'en'" [innerHTML]="(post.desc | truncate:400) | safeText"></p>
                        <p *ngIf="currentLang == 'kh'" [innerHTML]="(post.desc_kh | truncate:400) | safeText"></p>
                        <a href="all-posts/detail/{{ post.id }}" class="read-more-btn">Read More →</a>
                    </div>
                </div>

            </div>
            <!-- <div class="community">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <h2>{{ 'csr.Community Education on Safe Drinking Water, Hygiene and Sanitation' | translate }}</h2>
                        <p>{{ 'csr.To participate in social and community development, the Company has integrated the community education sessions on safe drinking water, hygiene and sanitation into its CwE program since 2016 in order to build client awareness of the risks of disease related to unimproved water and sanitation facilities, hygiene and sanitation basics, advantage of improved facilities and opportunity for WASH financing. In 2018, the Company conducted 80 community education sessions on the topic of Safe Drinking water, Hygiene and Sanitation with approximately 2,583 participants in the rural areas, in which 78% was female and 30% were clients.' | translate }}</p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <img [src]="baseApiUrl + '/uploads/images/publications/csr/csr_3.jpg'" alt="">
                    </div>
                </div>
            </div>
            <div class="financial">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <img [src]="baseApiUrl + '/uploads/images/publications/csr/csr_4.jpg'" alt="">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <h2>{{ 'csr.Financial Literacy Training Program' | translate }}</h2>
                        <p>{{ 'csr.In response to microfinance sector’s commitment to raising client awareness of savings, debt management, family cash flow management and credit discipline, NongHyup Finance (Cambodia) Plc, in partnership with CMA and Good Return, has conducted the Financial Literacy training program called Consumer Awareness and Financial Empowerment (CAFÉ). In 2018, NongHyup Finance provided CAFE program to 1,377 participants. Of these, 10% were NongHyup Finance’s clients and 79% were women. In 2020, NongHyup Finance have received the supporting from CMA and Good Return to adopt the new Financial Coaching called FEIRFIN (Financial Education Initiative for Responsible Financial Inclusion) and NongHyup Finance has provided this financial literacy training to 75 non and existing clients for the first quarter of 2020.' | translate }}</p>
                    </div>
                </div>
            </div> -->
            <div class="charity-work">
            <h1><span style="color: #005EB8;">{{ 'csr.Charity' | translate }}</span><span style="color: #FFB81C;"> {{ 'csr.Work' | translate }}</span></h1>
                <section>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel">
                
                                    <div class="carousel-inner">

                                        <div class="carousel-item active" *ngIf="charityWorkPosts.length > 0">
                                            <div class="row">
                                                <div class="col-md-6 mb-3" *ngFor="let post of charityWorkPosts | slice:0:2; let i = index">
                                                    <div class="card">
                                                        <a href="all-posts/detail/{{ post.id }}"><img class="img-fluid" alt="100%x280" [src]="baseApiUrl + '/' + post.banner_image_url"></a>
                                                        <div class="card-body">
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isEnglish()">{{ post.title }}</h5></a>
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isKhmer()">{{ post.title_kh }}</h5></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="carousel-item" *ngIf="charityWorkPosts.length > 2">
                                            <div class="row">
                                                <div class="col-md-6 mb-3" *ngFor="let post of charityWorkPosts | slice:2:4; let i = index">
                                                    <div class="card">
                                                        <a href="all-posts/detail/{{ post.id }}"><img class="img-fluid" alt="100%x280" [src]="baseApiUrl + '/' + post.banner_image_url"></a>
                                                        <div class="card-body">
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isEnglish()">{{ post.title }}</h5></a>
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isKhmer()">{{ post.title_kh }}</h5></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item" *ngIf="charityWorkPosts.length > 4">
                                            <div class="row">
                                                <div class="col-md-6 mb-3" *ngFor="let post of charityWorkPosts | slice:4:6; let i = index">
                                                    <div class="card">
                                                        <a href="all-posts/detail/{{ post.id }}"><img class="img-fluid" alt="100%x280" [src]="baseApiUrl + '/' + post.banner_image_url"></a>
                                                        <div class="card-body">
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isEnglish()">{{ post.title }}</h5></a>
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isKhmer()">{{ post.title_kh }}</h5></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <div class="carousel-item" *ngIf="charityWorkPosts.length > 6">
                                            <div class="row">
                                                <div class="col-md-6 mb-3" *ngFor="let post of charityWorkPosts | slice:6:8; let i = index">
                                                    <div class="card">
                                                        <a href="all-posts/detail/{{ post.id }}"><img class="img-fluid" alt="100%x280" [src]="baseApiUrl + '/' + post.banner_image_url"></a>
                                                        <div class="card-body">
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isEnglish()">{{ post.title }}</h5></a>
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isKhmer()">{{ post.title_kh }}</h5></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item" *ngIf="charityWorkPosts.length > 8">
                                            <div class="row">
                                                <div class="col-md-6 mb-3" *ngFor="let post of charityWorkPosts | slice:8:10; let i = index">
                                                    <div class="card">
                                                        <a href="all-posts/detail/{{ post.id }}"><img class="img-fluid" alt="100%x280" [src]="baseApiUrl + '/' + post.banner_image_url"></a>
                                                        <div class="card-body">
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isEnglish()">{{ post.title }}</h5></a>
                                                            <a href="all-posts/detail/{{ post.id }}"><h5 class="card-text" *ngIf="isKhmer()">{{ post.title_kh }}</h5></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                              
                            </div>
                            <div class="col-6 text-right">
                              <a class="btn btn-primary mb-3 mr-1" href="#carouselExampleIndicators2" role="button" data-slide="prev">
                                  <img [src]="baseApiUrl + '/uploads/images/icons/left_arrow.png'" alt="" style="width: auto; height: 15px;">
                              </a>
                              <a class="btn btn-primary mb-3 " href="#carouselExampleIndicators2" role="button" data-slide="next">
                                  <img [src]="baseApiUrl + '/uploads/images/icons/right_arrow.png'" alt="" style="width: auto; height: 15px;">
                              </a>
                            </div>
                        </div>
                    </div>
                  </section>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
